<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 sm3 md3>
				<app-profile-menu
					:customer="$page.props.auth.customer.display_name"
					:customer_image="$page.props.auth.customer_image"
				></app-profile-menu>
			</v-flex>
			<v-flex xs12 sm9 md9>
				<ValidationObserver ref="obs" v-slot="{ invalid }">
					<v-form>
						<v-card>
							<v-card-title primary-title>
								{{ $t("title.language") }}
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<v-layout row wrap>
									<v-flex xs12>
										<ValidationProvider
											name="locale"
											rules="required"
											v-slot="{ errors, valid }"
										>
											<v-select
												:label="$t('label.locale')"
												v-model="item.settings.locale"
												prepend-icon="mdi-translate"
												type="email"
												:error-messages="errors"
												:append-icon="
													valid ? 'mdi-check' : null
												"
												:items="[
													{
														value: 'en',
														text: 'English',
													},
													{
														value: 'km',
														text: 'ភាសាខ្មែរ',
													},
													{
														value: 'fr',
														text: 'français',
													},
													{
														value: 'zh',
														text: '中文',
													},
												]"
											></v-select>
										</ValidationProvider>
									</v-flex>
								</v-layout>
							</v-card-text>
							<v-divider></v-divider>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn
									color="primary"
									@click.native="submit()"
									:loading="item.processing"
									:disabled="invalid"
								>
									<v-icon left>mdi-content-save</v-icon>
									{{ $t("Update") }}
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-form>
				</ValidationObserver>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
export default {
	props: {
		auth: Object,
	},
	data() {
		return {
			item: this.$inertia.form({
				settings: this.auth.user?.settings ?? {},
			}),
		};
	},
	methods: {
		submit() {
			this.item.post(this.$route("language.store"), {
				onFinish: () => location.reload(),
			});
		},
	},
};
</script>